import styled from 'styled-components';
import { isMobile, isMobileOnly } from 'react-device-detect';
import Typography from '../Typography';
import type { SnackbarType } from './types';

export const StyledContainer = styled.div<{
    type: SnackbarType;
    $visible: boolean;
}>`
    position: fixed;
    z-index: 10000;

    // для mobile устройств всегда показываем Snackbar в центре экрана
    left: ${isMobile ? '50%' : '88px'};

    // для mobileOnly - на всю ширину, для tablet - по размеру контента
    min-width: ${isMobileOnly ? 'calc(100% - 2 * 10px)' : '256px'};

    display: flex;
    max-width: 600px;
    min-height: 40px;
    box-sizing: border-box;
    border-radius: 12px;
    padding: 8px 16px;

    ${({ type, theme }) => {
        if (type === 'error') {
            return `
                background: ${theme.root.colors.system.dangerDefault};
            `;
        }

        return `
            background: ${theme.root.colors.basicColors['90%']};
        `;
    }};

    ${({ $visible }) =>
        $visible
            ? `
                bottom: 16px;
                transform: translateY(0) ${isMobile ? `translateX(-50%)` : ''};
                opacity: 1
            `
            : `
                bottom: 0;
                transform: translateY(100%) ${isMobile ? `translateX(-50%)` : ''};
                opacity: 0;
            `};

    // специально не используем all, чтобы не анимировать background
    transition: bottom 0.3s ease, transform 0.3s ease, opacity 0.3s ease;
`;

export const StyledRowContainer = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
`;

export const StyledCountdownAndTextContainer = styled.div`
    display: flex;
    flex: 1;
    align-items: center;
    gap: 8px;
`;

export const StyledLabel = styled(Typography)<{ type: SnackbarType; $hasSideSlot: boolean }>`
    flex: 1;
    white-space: pre-line;

    ${({ type, theme }) => {
        if (type === 'error') {
            return `
                color: ${theme.root.colors.basicColors.white['100%']};
            `;
        }

        return `
            color: ${theme.root.colors.basicColors.inverted['100%']};
        `;
    }};

    text-align: ${({ $hasSideSlot }) => ($hasSideSlot ? 'left' : 'center')};
`;
